import i18n from '@/i18n'
import goodsFromComponent from './index.vue'
import _ from 'lodash'

const goodDetail = {}
goodDetail.install = function (Vue) {
  const ToastConstructor = Vue.extend(goodsFromComponent)
  // 生成一个该子类的实例
  const instance = new ToastConstructor({ i18n })
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  Vue.prototype.$modalGoodsDetailList = function (
    goodslists,
    multiSelect,
    callback
  ) {
    instance.dialogVisible = true
    instance.goodslists = goodslists
    instance.queryForm.goodcodes = _.map(goodslists, 'code')
    instance.multiSelect = multiSelect
    instance.callback = callback
  }
}
export default goodDetail
